export enum CasingOption {
  Uppercase,
  UserDefined,
  Capitalized,
  Lowercase,
}

const capitalizeFirst = (s: string) => s.charAt(0).toUpperCase() + s.substring(1, s.length).toLowerCase()
export const capitalize = (string: string, firstOnly: boolean = false): string => {
  const parts = string.split(' ')
  if (firstOnly) return capitalizeFirst(string)
  return parts.map(capitalizeFirst).join(' ')
}
export const lowercase = (string: string): string => string.toLowerCase()
export const uppercase = (string: string): string => string.toUpperCase()
// Currently, there are no necessary sanitization to user-defined casing.
export const sanitize = (string: string): string => string

export const transformStringCase = (string: string, option?: CasingOption) => {
  switch (option) {
    default:
    case CasingOption.Uppercase:
      return uppercase(string)

    case CasingOption.UserDefined:
      return sanitize(string)

    case CasingOption.Capitalized:
      return capitalize(string)

    case CasingOption.Lowercase:
      return lowercase(string)
  }
}

export const getCaseLabel = (casing: CasingOption) => {
  switch (casing) {
    default:
    case CasingOption.Uppercase: return 'AAA'
    case CasingOption.UserDefined: return 'AaA'
    case CasingOption.Capitalized: return 'Aaa'
    case CasingOption.Lowercase: return 'aaa'
  }
}
